module.exports = __webpack_public_path__ + "img/contactsImg3x.png";